/* SoWood product page — Macorner behaviours (countdown, delivery dates, modals,
   thumbnail strip, Customeow live preview, sticky bottom bar). */
(() => {
  const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const MONTHS_LONG = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  // two-column layout (vertical thumbnail strip) starts at 750px, like Macorner's grid--2-col-tablet
  const twoColQuery = window.matchMedia('(min-width: 750px)');

  const pad = (n) => String(n).padStart(2, '0');

  // Countdown to the visitor's local midnight, like Macorner's evergreen timer
  function initCountdowns(root) {
    const timers = root.querySelectorAll('[data-sw-countdown]');
    if (!timers.length) return;
    const tick = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const diff = Math.max(0, midnight - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      timers.forEach((t) => {
        t.querySelector('[data-sw-h]').textContent = pad(h);
        t.querySelector('[data-sw-m]').textContent = pad(m);
        t.querySelector('[data-sw-s]').textContent = pad(s);
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  // Sale banner % follows the price block, which Minimog re-renders on variant change
  function syncSaleBanner(root) {
    const banner = root.querySelector('[data-sw-sale-banner]');
    const price = root.querySelector('[data-sw-pct]');
    if (!banner || !price) return;
    const pct = parseInt(price.dataset.swPct, 10) || 0;
    banner.querySelector('[data-sw-sale-pct]').textContent = pct;
    banner.hidden = pct <= 0;
  }

  function formatRange(from, to, months) {
    if (from.getMonth() === to.getMonth()) return `${months[from.getMonth()]} ${from.getDate()}-${to.getDate()}`;
    return `${months[from.getMonth()]} ${from.getDate()} - ${months[to.getMonth()]} ${to.getDate()}`;
  }

  function addDays(days) {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  }

  // Delivery estimate is computed in the browser so cached pages never show stale dates
  function initDelivery(root) {
    const delivery = root.querySelector('[data-sw-delivery]');
    if (!delivery) return;
    const min = parseInt(delivery.dataset.min, 10);
    const max = parseInt(delivery.dataset.max, 10);
    const pMin = parseInt(delivery.dataset.prodMin, 10);
    const pMax = parseInt(delivery.dataset.prodMax, 10);
    const update = () => {
      const months = desktopQuery.matches ? MONTHS_LONG : MONTHS_SHORT;
      const eta = delivery.querySelector('[data-sw-eta]');
      if (eta) eta.textContent = formatRange(addDays(min), addDays(max), months);
      document.querySelectorAll('[data-sw-timeline]').forEach((tl) => {
        const today = new Date();
        tl.querySelector('[data-sw-date="placed"]').textContent = `${MONTHS_SHORT[today.getMonth()]} ${today.getDate()}`;
        tl.querySelector('[data-sw-date="ships"]').textContent = formatRange(addDays(pMin), addDays(pMax), MONTHS_SHORT);
        tl.querySelector('[data-sw-date="delivered"]').textContent = formatRange(addDays(min), addDays(max), MONTHS_SHORT);
      });
    };
    update();
    desktopQuery.addEventListener('change', update);
  }

  // Modals live inside the section markup; move them to <body> so no transformed
  // ancestor can break position: fixed.
  function initModals(root) {
    root.querySelectorAll('.sw-pdp-modal').forEach((modal) => {
      const existing = document.getElementById(modal.id);
      if (existing && existing !== modal) existing.remove();
      document.body.appendChild(modal);
      modal.addEventListener('click', (e) => {
        if (e.target === modal || e.target.closest('[data-sw-modal-close]')) closeModal(modal);
      });
    });
    root.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-sw-modal-open]');
      if (!opener) return;
      const modal = document.getElementById(opener.dataset.swModalOpen);
      if (modal) openModal(modal, opener);
    });
  }

  let lastOpener = null;
  function openModal(modal, opener) {
    lastOpener = opener;
    modal.hidden = false;
    document.documentElement.classList.add('sw-pdp-modal-open');
    modal.querySelector('[data-sw-modal-close]')?.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('sw-pdp-modal-open');
    lastOpener?.focus();
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.sw-pdp-modal:not([hidden])').forEach(closeModal);
  });

  // Our thumbnail strip drives Minimog's Swiper slider
  function initThumbs(root) {
    const strip = root.querySelector('[data-sw-thumbs]');
    const gallery = root.querySelector('media-gallery');
    if (!strip || !gallery) return;
    const list = strip.querySelector('.sw-pdp-thumbs__list');
    const items = [...strip.querySelectorAll('.sw-pdp-thumbs__item')];
    let bound = null;

    const setActive = (index) => {
      items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      const active = items[index];
      if (!active) return;
      if (twoColQuery.matches) {
        const top = active.offsetTop - (list.clientHeight - active.offsetHeight) / 2;
        list.scrollTo({ top, behavior: 'smooth' });
      } else {
        const left = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
        list.scrollTo({ left, behavior: 'smooth' });
      }
    };

    const bind = () => {
      const slider = gallery.slider;
      if (!slider || typeof slider !== 'object' || slider === bound) return;
      bound = slider;
      slider.on('slideChange', () => setActive(slider.realIndex ?? slider.activeIndex));
      setActive(slider.realIndex ?? slider.activeIndex ?? 0);
    };

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const index = parseInt(item.dataset.index, 10);
        const slider = gallery.slider;
        if (slider && typeof slider === 'object') {
          if (slider.params.loop) slider.slideToLoop(index);
          else slider.slideTo(index);
        }
        setActive(index);
      });
    });

    bind();
    const poll = setInterval(bind, 300);
    setTimeout(() => clearInterval(poll), 10000);
    window.addEventListener('resize', bind);
  }

  // Customeow embed mode: its live preview is rendered into [data-sw-live-preview],
  // which we place over the main image and reveal once the shopper starts customizing.
  function initLivePreview(root, state) {
    const preview = root.querySelector('[data-sw-live-preview]');
    const embed = root.querySelector('.customeow-block-embed-container');
    if (!preview || !embed) return;

    const galleryInner = root.querySelector('.m-media-gallery__inner');
    if (galleryInner && preview.parentElement !== galleryInner) galleryInner.appendChild(preview);

    const previewButtons = root.querySelectorAll('[data-sw-preview]');
    // Forms with no preview template leave Customeow's wrapper empty; covering the
    // photo with it shows a blank white box, so wait for something to be drawn.
    const hasPreview = () => preview.querySelector('[data-type="customeow-preview"] *');
    const activate = () => {
      state.customizing = true;
      if (hasPreview()) root.classList.add('is-previewing');
    };
    new MutationObserver(() => state.customizing && activate()).observe(preview, { childList: true, subtree: true });

    const onEmbedReady = () => {
      if (!embed.children.length || state.embedActive) return;
      state.embedActive = true;
      previewButtons.forEach((b) => (b.hidden = false));
      state.refreshSticky?.();
    };

    new MutationObserver(onEmbedReady).observe(embed, { childList: true });
    onEmbedReady();

    ['pointerdown', 'input', 'change'].forEach((type) => embed.addEventListener(type, activate, { passive: true }));

    // Customeow only portals the preview onto the gallery above 768px; on phones it stays
    // at the top of the personalization panel, so Preview scrolls there instead.
    state.showPreview = () => {
      activate();
      const inGallery = preview.children.length && preview.querySelector('[data-type="customeow-preview"] *');
      const target = inGallery
        ? root.querySelector('.m-product-media--wrapper')
        : embed.querySelector('._module_item_preview') || embed;
      const top = target.getBoundingClientRect().top + window.scrollY - stickyHeaderHeight() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };
    previewButtons.forEach((b) => b.addEventListener('click', () => state.showPreview()));
  }

  // The store header is sticky on mobile; keep scroll targets below it
  function stickyHeaderHeight() {
    let bottom = 0;
    document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header-group *').forEach((el) => {
      const pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      const r = el.getBoundingClientRect();
      if (r.top <= 1 && r.height > 0 && r.height < window.innerHeight / 2) bottom = Math.max(bottom, r.bottom);
    });
    return bottom;
  }

  function primaryButton(root) {
    const custom = root.querySelector('.customeow-block-btn-add');
    if (custom && custom.offsetParent !== null) return custom;
    return root.querySelector('.m-add-to-cart[name="add"]');
  }

  // Sticky bar: shown once the gallery has scrolled away, hidden while the page's own
  // buttons are on screen (Macorner: two IntersectionObservers on the same bar).
  function initSticky(root, state) {
    const bar = root.querySelector('[data-sw-sticky]');
    if (!bar) return;
    const btn = bar.querySelector('[data-sw-sticky-btn]');
    const label = bar.querySelector('[data-sw-sticky-label]');
    const icon = bar.querySelector('[data-sw-sticky-icon]');
    const media = root.querySelector('.m-main-product--media');
    let galleryPassed = false;
    let ctaVisible = false;
    let ctaObserver = null;

    const render = () => {
      const show = galleryPassed && !ctaVisible;
      bar.classList.toggle('is-hidden', !show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
    };

    const watchCta = () => {
      ctaObserver?.disconnect();
      const target = state.embedActive ? root.querySelector('[data-sw-preview]') : primaryButton(root);
      if (!target) return;
      ctaObserver = new IntersectionObserver((entries) => {
        ctaVisible = entries[0].isIntersecting;
        render();
      });
      ctaObserver.observe(target);
    };

    state.refreshSticky = () => {
      if (state.embedActive) {
        label.textContent = 'Preview';
        icon.hidden = false;
      } else {
        const primary = primaryButton(root);
        const text = primary?.querySelector('.m-add-to-cart--text, .customeow-block-btn-label')?.textContent.trim();
        if (text) label.textContent = text;
        icon.hidden = true;
      }
      watchCta();
    };

    if (media) {
      new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) galleryPassed = false;
          else if (entry.boundingClientRect.top < 0) galleryPassed = true;
          render();
        },
        { rootMargin: '-150px 0px 0px 0px' }
      ).observe(media);
    }

    btn.addEventListener('click', () => {
      if (state.embedActive && state.showPreview) {
        state.showPreview();
        return;
      }
      primaryButton(root)?.click();
    });

    state.refreshSticky();
    // Customeow swaps its button label after loading its data
    setTimeout(() => state.refreshSticky(), 4000);
  }

  // Judge.me badge text "50 reviews" -> "(50)" like Macorner
  function initRatingBadge(root) {
    const apply = () => {
      root.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
        const count = badge.dataset.numberOfReviews;
        const text = badge.querySelector('.jdgm-prev-badge__text');
        if (text && count && text.textContent !== `(${count})`) text.textContent = `(${count})`;
      });
    };
    apply();
    setTimeout(apply, 1500);
  }

  // Minimog prints "Size:"; Macorner's legend has no colon
  function tidyOptionLabels(root) {
    root.querySelectorAll('.option-label--title').forEach((el) => {
      el.textContent = el.textContent.replace(/:\s*$/, '');
    });
  }

  function init(root) {
    if (!root || root.dataset.swPdpReady) return;
    root.dataset.swPdpReady = 'true';
    const state = { embedActive: false };
    initCountdowns(root);
    syncSaleBanner(root);
    initDelivery(root);
    initModals(root);
    initThumbs(root);
    initLivePreview(root, state);
    initSticky(root, state);
    initRatingBadge(root);
    tidyOptionLabels(root);
    document.addEventListener('variant:changed', () => {
      syncSaleBanner(root);
      tidyOptionLabels(root);
    });
  }

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };

  // Judge.me review widget -> Macorner layout: summary card (score, bars, write button),
  // "Reviews with Images" strip and star filter chips above the list.
  function initReviews(section) {
    if (section.dataset.swReady) return;
    section.dataset.swReady = 'true';
    const labels = section.dataset;

    section.querySelectorAll('[data-sw-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        section.querySelectorAll('[data-sw-tab]').forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
        });
        section.querySelectorAll('[data-sw-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.swPanel !== tab.dataset.swTab;
        });
      });
    });

    const buildCard = (widg) => {
      const header = widg.querySelector('.jdgm-rev-widg__header');
      if (!header) return;
      const avg = parseFloat(widg.dataset.averageRating) || 0;
      const count = parseInt(widg.dataset.numberOfReviews, 10) || 0;

      const card = el('div', 'sw-rv-card');
      card.append(el('div', 'sw-rv-card__title', labels.itemTitle));
      const score = el('div', 'sw-rv-score');
      score.append(el('span', 'sw-rv-score__avg', avg.toFixed(1)), el('hr', 'sw-rv-score__divider'));
      const right = el('div');
      const stars = el('div', 'sw-rv-stars');
      stars.style.setProperty('--sw-rating', avg);
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${avg.toFixed(1)} / 5`);
      right.append(stars, el('span', 'sw-rv-score__count', count ? `${count} Review${count === 1 ? '' : 's'}` : 'No reviews yet'));
      if (!count) card.classList.add('sw-rv-card--empty');
      score.append(right);
      card.append(score);
      header.prepend(card);
    };

    // Judge.me re-renders its header after setup, so pull the histogram, the write button
    // and the form into the card every time it does.
    const fillCard = (widg) => {
      const card = widg.querySelector('.sw-rv-card');
      if (!card) return;
      const count = parseInt(widg.dataset.numberOfReviews, 10) || 0;
      const histogram = widg.querySelector('.jdgm-histogram');
      if (histogram && count > 0 && histogram.parentElement !== card) card.querySelector('.sw-rv-score').after(histogram);
      const actions = widg.querySelector('.jdgm-widget-actions-wrapper');
      if (actions && actions.parentElement !== card) card.append(actions);
      const form = widg.querySelector('.jdgm-form-wrapper');
      if (form && form.previousElementSibling !== card) card.after(form);
    };

    const buildRight = (widg) => {
      const body = widg.querySelector('.jdgm-rev-widg__body');
      if (!body) return null;
      let right = widg.querySelector('.sw-rv-right');
      if (!right) {
        right = el('div', 'sw-rv-right');
        const images = el('div', 'sw-rv-images');
        images.hidden = true;
        images.append(el('h3', 'sw-rv-heading', labels.imagesTitle), el('div', 'sw-rv-images__track'));
        const listHead = el('div', 'sw-rv-list-head');
        listHead.append(el('h3', 'sw-rv-heading', labels.listTitle), el('div', 'sw-rv-chips'));
        const list = el('div', 'sw-rv-list');
        right.append(images, listHead, list);
        body.before(right);
        list.append(body);
      }
      return right;
    };

    const buildChips = (widg, right) => {
      const chips = right.querySelector('.sw-rv-chips');
      if (chips.childElementCount) return;
      const count = parseInt(widg.dataset.numberOfReviews, 10) || 0;
      right.querySelector('.sw-rv-list-head').hidden = count === 0;
      const rows = [...widg.querySelectorAll('.jdgm-histogram__row[data-rating]:not(.jdgm-histogram__clear-filter)')];
      const make = (label, n, onClick) => {
        const chip = el('button', 'sw-rv-chip');
        chip.type = 'button';
        chip.append(document.createTextNode(label), el('span', 'sw-rv-chip__count', `(${n})`));
        chip.disabled = n === 0;
        chip.addEventListener('click', () => {
          chips.querySelectorAll('.sw-rv-chip').forEach((c) => c.classList.toggle('is-active', c === chip));
          onClick();
        });
        chips.append(chip);
        return chip;
      };
      make(labels.allLabel, count, () => widg.querySelector('.jdgm-histogram__clear-filter')?.click()).classList.add('is-active');
      rows
        .sort((a, b) => b.dataset.rating - a.dataset.rating)
        .forEach((row) => {
          make(`${row.dataset.rating} Star`, parseInt(row.dataset.frequency, 10) || 0, () =>
            (row.querySelector('.jdgm-histogram__star') || row).click()
          );
        });
    };

    const buildImages = (widg, right) => {
      const box = right.querySelector('.sw-rv-images');
      const track = box.querySelector('.sw-rv-images__track');
      const links = [...widg.querySelectorAll('.jdgm-rev .jdgm-rev__pic-link')].filter((a) => a.querySelector('img'));
      const key = links.map((a) => a.href || a.querySelector('img').src).join('|');
      if (track.dataset.key === key) return;
      track.dataset.key = key;
      track.replaceChildren(
        ...links.map((link) => {
          const img = link.querySelector('img');
          const item = el('button', 'sw-rv-images__item');
          item.type = 'button';
          const thumb = el('img');
          thumb.src = img.currentSrc || img.src || img.dataset.src || '';
          thumb.alt = img.alt || '';
          thumb.loading = 'lazy';
          item.append(thumb);
          item.addEventListener('click', () => link.click());
          return item;
        })
      );
      box.hidden = links.length === 0;
    };

    let timer = null;
    const apply = () => {
      const widg = section.querySelector('.jdgm-rev-widg');
      if (!widg || !widg.querySelector('.jdgm-rev-widg__header')) return;
      if (!widg.dataset.swBuilt) {
        widg.dataset.swBuilt = 'true';
        buildCard(widg);
      }
      fillCard(widg);
      const right = buildRight(widg);
      if (!right) return;
      buildChips(widg, right);
      buildImages(widg, right);
    };
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    }).observe(section, { childList: true, subtree: true });
    apply();
  }

  // Shopify related-product recommendations when the section has no collection
  function initRelated(section) {
    if (section.dataset.swReady || !section.dataset.url) return;
    section.dataset.swReady = 'true';
    const load = () =>
      fetch(section.dataset.url)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const grid = html.querySelector('[data-sw-related-grid]');
          const target = section.querySelector('[data-sw-related-grid]');
          if (grid && target) target.innerHTML = grid.innerHTML;
          if (!target?.children.length) section.hidden = true;
        })
        .catch(() => (section.hidden = true));
    new IntersectionObserver((entries, obs) => {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      load();
    }, { rootMargin: '0px 0px 400px 0px' }).observe(section);
  }

  // Footer menu titles are typed in capitals ("GET IN TOUCH"); Macorner uses sentence case
  function sentenceCaseFooterTitles() {
    document.querySelectorAll('.shopify-section-group-footer-group .m-footer--block-title').forEach((title) => {
      const node = [...title.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      if (!node) return;
      const text = node.textContent.trim();
      if (text !== text.toUpperCase()) return;
      const lower = text.toLowerCase();
      node.textContent = node.textContent.replace(text, lower.charAt(0).toUpperCase() + lower.slice(1));
    });
  }

  // After a successful Add to Cart, Macorner shows "Item has been added to your shopping cart" (a bottom
  // sheet on phones, a centred box on desktop) with Keep Shopping / View Cart & Checkout; there is no
  // cart drawer. Customeow's inline form reports customeow-cart-completed (after posting /cart/add.js
  // itself); the theme form (and Customeow's popup, which submits it) reports product-ajax:added.
  const cartUrl = () => window.MinimogSettings?.routes?.cart || `${window.Shopify?.routes?.root || '/'}cart`;

  const escapeHtml = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // "$41.95 USD" like the cart page (money_with_currency)
  function formatMoney(cents) {
    const settings = window.MinimogSettings || {};
    const active = window.Shopify?.currency?.active || settings.currency_code;
    const amount = (Number(cents) || 0) / 100;
    const format = settings.money_with_currency_format;
    if (format && active === settings.currency_code) {
      const withDecimals = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amount).toLocaleString('en-US'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals.replace(/,/g, ' ').replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withDecimals);
    }
    return `${new Intl.NumberFormat('en-US', { style: 'currency', currency: active || 'USD' }).format(amount)} ${active || ''}`.trim();
  }

  // Keep the header cart count right after Customeow's own /cart/add.js (the theme form already does it).
  async function refreshCartSections() {
    const { MinimogEvents, MinimogTheme } = window;
    if (!MinimogEvents || !MinimogTheme) return;
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } }));
    if (!sections.length) return;
    try {
      const rendered = await fetch(`${window.Shopify.routes.root}?sections=${[...new Set(sections)].join(',')}`).then((r) => r.json());
      MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: { sections: rendered } });
    } catch (err) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  function closeAdded() {
    const box = document.querySelector('.sw-pdp-added');
    if (!box) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('sw-pdp-added-open');
    setTimeout(() => box.remove(), 300);
    box._opener?.focus?.();
  }

  function showAdded(item) {
    if (!item) {
      window.location.href = cartUrl();
      return;
    }
    document.querySelector('.sw-pdp-added')?.remove();
    const props = item.properties || {};
    const design = [props['preview.effects'], props._Preview].find((url) => /^https?:\/\//.test(String(url || '').trim()));
    const image = design || item.featured_image?.url || item.image || '';
    const options = (item.options_with_values || []).filter((o) => o.name !== 'Title');
    const check =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
    const chevron =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';

    const box = document.createElement('div');
    box.className = 'sw-pdp-added';
    box._opener = document.activeElement;
    box.innerHTML = `
      <div class="sw-pdp-added__box" role="dialog" aria-modal="true" aria-labelledby="SwPdpAddedTitle">
        <p class="sw-pdp-added__title" id="SwPdpAddedTitle">${check}Item has been added to your shopping cart</p>
        <div class="sw-pdp-added__item">
          <div class="sw-pdp-added__img">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="300" height="300">` : ''}</div>
          <div class="sw-pdp-added__info">
            <p class="sw-pdp-added__name">${escapeHtml(item.product_title || item.title)}</p>
            ${options.map((o) => `<p class="sw-pdp-added__opt">${escapeHtml(o.name)}:<span>${escapeHtml(o.value)}</span></p>`).join('')}
            <p class="sw-pdp-added__opt sw-pdp-added__opt--qty">Quantity:<span>${escapeHtml(item.quantity)}</span></p>
            <p class="sw-pdp-added__price">${escapeHtml(formatMoney(item.final_line_price ?? item.line_price ?? item.price))}</p>
          </div>
        </div>
        <div class="sw-pdp-added__actions">
          <button type="button" class="sw-pdp-added__btn" data-sw-added-close>Keep Shopping</button>
          <a class="sw-pdp-added__btn sw-pdp-added__btn--cart" href="${escapeHtml(cartUrl())}">View Cart &amp; Checkout${chevron}</a>
        </div>
      </div>`;
    box.addEventListener('click', (e) => {
      if (e.target === box || e.target.closest('[data-sw-added-close]')) closeAdded();
    });
    document.body.append(box);
    document.documentElement.classList.add('sw-pdp-added-open');
    requestAnimationFrame(() => requestAnimationFrame(() => box.classList.add('is-open')));
    box.querySelector('.sw-pdp-added__btn--cart').focus({ preventScroll: true, focusVisible: false });
  }

  async function onAdded(event) {
    const fromCustomeow = event.type === 'customeow-cart-completed';
    let item = event.detail?.product;
    if (!item?.variant_id) {
      try {
        // A personalized line is always new, and Shopify puts new lines first.
        const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
        item = cart.items?.[0];
      } catch (err) {
        item = null;
      }
    }
    showAdded(item);
    if (fromCustomeow) refreshCartSections();
  }

  // FoxKit's pre-purchase upsell ("Add Some Lovely Card") opens right after an add; SoWood will use its
  // own gift-box add-on instead, so drop the modal (and the scroll lock it sets).
  function dropFoxKitPrePurchase() {
    new MutationObserver((records) => {
      records.forEach((r) =>
        r.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches('.foxkit-modal__wrapper.foxkit-pre-purchase')) {
            node.remove();
            if (!document.querySelector('.sw-pdp-added')) document.documentElement.classList.remove('prevent-scroll');
          }
        })
      );
    }).observe(document.body, { childList: true });
  }

  const start = () => {
    if (document.body.classList.contains('template-product') && !window.swPdpCartHook) {
      window.swPdpCartHook = true;
      document.addEventListener('customeow-cart-completed', onAdded);
      document.addEventListener('product-ajax:added', onAdded);
      document.addEventListener('keydown', (e) => e.key === 'Escape' && closeAdded());
      dropFoxKitPrePurchase();
    }
    if (document.body.classList.contains('template-product')) {
      sentenceCaseFooterTitles();
    }
    document.querySelectorAll('product-info.sw-pdp').forEach(init);
    document.querySelectorAll('[data-sw-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-sw-related]').forEach(initRelated);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
